const discountTypeEnum = Object.freeze({
    FIXED          : 5,
    PERCENTAGE     : 10,
});
export default discountTypeEnum;
